import { render, staticRenderFns } from "./IconCreditCard.vue?vue&type=template&id=9ca2354c&"
import script from "./IconCreditCard.vue?vue&type=script&lang=js&"
export * from "./IconCreditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports